export default class CreateManyPodsDuplicateUuidsError extends Error {
  /**
   * @type {string[]}
   */
  duplicateUuids;

  /**
   *
   * @param {string[]} duplicateUuids
   */
  constructor(duplicateUuids) {
    super('There are some duplicate UUIDs');
    this.duplicateUuids = duplicateUuids;
  }
}
